module.exports = __webpack_public_path__ + "img/roller-brush.f1548ec0.svg";